export const getActiveOrganization = state => {
  const user = (state.auth && state.auth.user) || {};
  const organization = user.organizations || [];
  return organization.find(org => org.id === user.activeOrganizationId) || {};
};

export const isActiveOrgIntermediary = state =>
  Boolean(getActiveOrganization(state)?.intermediary);
